import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, type EdgeProps } from '@xyflow/react';
import { IconButton } from '@mui/joy';
import { Plus as AddIcon } from '@phosphor-icons/react';

interface AddableEdgeData {
  onAdd?: (edgeId: string) => void;
}

export default function AddableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgeData = data as unknown as AddableEdgeData;

  const onEdgeClick = () => {
    if (edgeData?.onAdd) {
      edgeData.onAdd(id);
    }
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
        >
          <IconButton
            size="sm"
            color="primary"
            variant="solid"
            onClick={onEdgeClick}
            sx={{
              minWidth: 24,
              minHeight: 24,
              padding: '2px',
              borderRadius: '50%',
            }}
          >
            <AddIcon size={14} />
          </IconButton>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}